import * as React from 'react';
import _ from 'lodash';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Divider, Tooltip, IconButton } from '@mui/material';
import Iconify from '../../../../components/Iconify';

export default function TabsContainer({ tabs, currentTab, handleChangeTab, handleRemoveTab }) {
  const handleRemoveTabContainter = (e, tabId) => {
    e.stopPropagation();
    handleRemoveTab(tabId);
  };

  return (
    <Box sx={{ width: '100%' }}>
      { _.isEmpty(tabs) ? null
        : <Tabs
          value={currentTab}
          onChange={(e, id) => handleChangeTab(e, id)}
          indicatorColor="secondary"
          textColor="primary"
        >
          <Tab label="Pracownik" value={null} />
          {tabs && _.map(tabs, (tab, key) => <Tab key={key} label={tab.name} value={tab.id} iconPosition="end"
            icon={ <Tooltip title="Przejdź do aplikacji">
              <IconButton color="primary" onClick={e => handleRemoveTabContainter(e, tab.id)}>
                <Iconify icon={'eva:close-fill'} width={20} height={20} />
              </IconButton>
            </Tooltip>} />
          )}
        </Tabs>
      }
      <Divider />
    </Box>
  );
}
